var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturns = function SvgReturns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.101 16.655c0 7.08-5.74 12.819-12.819 12.819-5.46 0-10.123-3.414-11.971-8.224a1.2 1.2 0 0 0-.798-.017c-.394.131-.533.445-.51.858C4.143 27.318 9.282 31 15.281 31c7.923 0 14.346-6.423 14.346-14.345S23.205 2.309 15.282 2.309a14.3 14.3 0 0 0-8.117 2.516c.153.088.335.164.537.231.325.108.521.441.675.796a12.76 12.76 0 0 1 6.905-2.017c7.08 0 12.82 5.74 12.82 12.82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.813 6.904a.613.613 0 0 0-.367-.79L8.5 5.058a.23.23 0 0 1-.139-.298l1.085-2.935a.613.613 0 0 0-1.15-.425L6.805 5.424a.31.31 0 0 0 .186.4l4.043 1.444a.613.613 0 0 0 .78-.364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.75,
    d: "M28.101 16.655c0 7.08-5.74 12.819-12.819 12.819-5.46 0-10.123-3.414-11.971-8.224a1.2 1.2 0 0 0-.798-.017c-.394.131-.533.445-.51.858C4.143 27.318 9.282 31 15.281 31c7.923 0 14.346-6.423 14.346-14.345S23.205 2.309 15.282 2.309a14.3 14.3 0 0 0-8.117 2.516c.153.088.335.164.537.231.325.108.521.441.675.796a12.76 12.76 0 0 1 6.905-2.017c7.08 0 12.82 5.74 12.82 12.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.75,
    d: "M11.813 6.904a.613.613 0 0 0-.367-.79L8.5 5.058a.23.23 0 0 1-.139-.298l1.085-2.935a.613.613 0 0 0-1.15-.425L6.805 5.424a.31.31 0 0 0 .186.4l4.043 1.444a.613.613 0 0 0 .78-.364Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 23.869a.55.55 0 0 1-.271-.073l-6.134-3.444a.56.56 0 0 1-.285-.487v-6.861a.56.56 0 0 1 .285-.487l6.134-3.444a.54.54 0 0 1 .543 0l6.134 3.444a.56.56 0 0 1 .285.487v6.86a.56.56 0 0 1-.285.488l-6.134 3.444a.55.55 0 0 1-.271.073m0 0v-7.435m6.691-3.717-6.627 3.717-6.754-3.717"
  })));
};
export default SvgReturns;